// kit.js: "Monte seu trio" (F5; módulo; orçamento ≤ 4 KiB = 4.096 B minificado, JARVIS no L10t; antes 3.840 B, L9n). Sem este arquivo o bloco fica no estado do carrinho
// que o servidor desenhou (vagas e CTA), sem escolher nem adicionar.
// - Vagas: primeiro as camisetas do trio que já estão no carrinho (JSON de snippets/trio-itens: na página e no corpo do
//   drawer, relido a cada cr:cart:html do cart.js), depois as escolhas pendentes da folha (card no modo "escolher" →
//   cr:kit:escolher), depois as vazias ("Escolher"). Uma escolha pendente toca para trocar.
// - CTA: n < k sem fechar → leva à 1ª vaga vazia; fecha com pendentes → "Adicionar o trio ao carrinho" (um POST com as
//   pendentes por CR.cart.adicionar, AddToCart com quantidade 1 por variante); k ou mais no carrinho → abre o drawer.
// - CR.cart (assets/cart.js) é global (window.CR); o kit só age por clique, com os dois módulos já carregados.
// - Total do kit montado = arredondar(Σ preços × (1 − pct/100)) no total, como a Yampi. Barra: is-on até n, com transição.
let ocupado = false;
const real = (c) => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/ /g, ' ').replace(/,00$/, '');
const kit = document.querySelector('[data-cr-kit]');
if (kit) {
  const $ = (s) => kit.querySelector(s);
  const T = JSON.parse($('[data-kit-textos]').textContent);
  const k = +kit.dataset.k;
  const fator = 1 - (+kit.dataset.pct || 0) / 100;
  const molde = (t) => $(`[data-kit-t${t}]`).content.firstElementChild.cloneNode(true);
  let cart = JSON.parse($('[data-kit-carrinho]').textContent);
  let picks = [];
  let alvo = 0; // índice da vaga que abriu a folha
  let nAntes = -1;
  // L9n (MK-S4): vaga provisória = a peça da PDP com o tamanho escolhido, fora do carrinho, na 1ª vaga livre; conta no n,
  // na barra e no CTA, e entra no POST do "Adicionar o trio". lote = provisória + pendentes; off = 1ª vaga das pendentes
  const P = JSON.parse($('[data-kit-prov]')?.textContent || 'null');
  // L9n-1 (Riff): lido conta as leituras reais (cr:cart:html); quantas unidades de uma variante há no carrinho
  let prov = null, lote = [], off = 0, avAntes, lido = 0;
  const qv = (c, id) => c.reduce((s, u) => s + (u.v === id ? u.q : 0), 0);
  const unid = () => cart.flatMap((u) => Array(u.q).fill(u));
  const alt = (v, s = T.alt) => s.replace('EEE', v.e).replace('LLL', v.l === 'baby' ? T.lBaby : T.lMasc).replace('SSS', v.t);
  const N = (s, n) => s.replace('NNN', n);
  const st = $('[data-kit-status]');
  const marcado = () => document.querySelector('[data-cr-sra="tamanhos"] input:checked');

  const pintar = () => {
    const c = unid();
    const nc = c.length;
    const pv = prov && nc < k ? [prov] : [];
    off = nc + pv.length;
    picks = picks.slice(0, Math.max(0, k - off));
    lote = [...pv, ...picks];
    const todas = [...c.slice(0, k), ...lote];
    const n = todas.length;
    // vagas pelos moldes do kit-trio (texto por textContent/atributo: nada de HTML montado com dado do catálogo)
    $('[data-kit-vagas]').replaceChildren(...Array.from({ length: k }, (_, i) => {
      const v = todas[i];
      const q = v && v === prov;
      const li = molde(v ? (i < nc ? 'c' : q ? 'q' : 'p') : 'v');
      const b = li.querySelector('button');
      const alvoAria = b || li;
      // rótulo só nos botões (vaga vazia, pendente e provisória); a vaga do carrinho é descrita pelo alt da miniatura
      // ajuste A do Gancho (L9n): o nome da provisória diz o estado e a ação (o aria-label tapa o alt da miniatura)
      if (b) { b.dataset.vagaBtn = i; b.ariaLabel = q ? `${alt(v, T.pa)}. ${T.pt}` : v ? `${T.trocar}: ${alt(v)}` : N(T.vazia, i + 1); }
      if (v) {
        const img = li.querySelector('img');
        img.src = v.i || '';
        img.alt = alt(v, q ? T.pa : T.alt);
        li.querySelector('span').textContent = q ? alt(v, T.pq) : v.t;
        if (~nAntes && i >= nAntes) alvoAria.classList.add('is-nova'); // ~(-1) = 0: 1ª pintura não anima
      }
      return li;
    }));
    $('[data-kit-conta]').textContent = N(T.conta, n);
    const seg = $('[data-kit-seg]');
    seg.ariaValueNow = n;
    seg.ariaValueText = N(T.prog, n);
    // a barra não é refeita (só as classes mudam), então a transição do CSS acontece sozinha
    [...seg.children].forEach((s, i) => s.classList.toggle('is-on', i < n));
    seg.classList.toggle('is-completo', nc >= k);
    const cta = $('[data-kit-cta]');
    const preco = $('[data-kit-preco]');
    cta.dataset.e = nc >= k ? 'completo' : n >= k ? 'adicionar' : 'falta';
    cta.textContent = nc >= k ? T.completo : n >= k ? T.adicionar : n ? (k - n === 1 ? T.f1 : N(T.fN, k - n)) : T.c0;
    $('[data-kit-mais]').hidden = nc <= k;
    preco.textContent = '';
    if (lote.length && n >= k) {
      const total = Math.round(todas.reduce((s, v) => s + v.p, 0) * fator);
      const babys = todas.filter((v) => v.l === 'baby').length;
      const R = (s, c = total) => s.replace('TTT', real(c));
      preco.textContent = todas.some((v) => v.x) ? R(T.plus)
        : babys === n ? R(T.baby)
          : babys ? R(T.misto, +kit.dataset.trioMasc)
            : new Set(todas.map((v) => v.p)).size === 1 ? R(T.masc).replace('CCC', real(Math.round(todas[0].p * fator))) : R(T.plus);
    }
    // MK-L: avisa quando muda o n ou o estado (2 + 1 escolhida → 3 no carrinho não muda o n, mas vira "Trio completo.")
    const av = nc >= k ? T.avisoOk : N(T.aviso, n);
    // L9n: compara com o último MK-L (não com o texto da região, que pode ter o MK-L2), senão repintar reanuncia o mesmo n
    if (~nAntes && av !== avAntes) st.textContent = av;
    nAntes = n;
    avAntes = av;
  };

  // L10t (AUD-U): a escolha vem da folha de tamanho (assets/rapido.js; miniatura em data-img) ou, sem ela, do formulário
  // de reserva do card. Fecha as duas folhas (tamanho e "Escolha uma camiseta"), preenche a vaga, anuncia (SL-16) e põe
  // o foco na vaga preenchida (ESPEC-SELETOR §1 passo 5 e §5)
  document.addEventListener('cr:kit:escolher', ({ detail: { f, r } }) => {
    f.closest('details')?.removeAttribute('open');
    f.closest('dialog')?.close();
    document.getElementById('cr-kit-folha')?.close();
    if (ocupado) return; // L9b-v2-1 (Riff): durante o POST do trio as pendentes não mudam (a confirmação usa o lote enviado)
    const v = { v: r.value, p: +r.dataset.preco, t: r.dataset.tam, x: r.dataset.plus === 'true', l: f.dataset.linha, e: f.dataset.estampa, i: f.dataset.img || f.closest('[data-cr-rapido]')?.querySelector('img')?.src };
    let i = alvo - off;
    if (i >= 0 && i < picks.length) picks[i] = v; else i = picks.push(v) - 1;
    pintar();
    st.textContent = alt(v, T.ent);
    $(`[data-vaga-btn="${off + i}"]`)?.focus();
  });
  // L9n: a PDP terminou de aplicar a seleção (tamanho ou cor): a provisória segue o rádio marcado; MK-L2 quando o
  // tamanho entra ou muda. Durante o POST do trio o lote enviado não muda
  document.addEventListener('cr:variante', () => {
    if (ocupado) return;
    const r = marcado();
    const d = P && r && P.v[r.value];
    const t = prov?.t;
    prov = d ? { v: r.value, p: d[0], t: d[1], x: d[2], i: d[3], l: P.l, e: P.e, q: 1 } : null;
    pintar();
    if (d && d[1] !== t) st.textContent = alt(prov, T.pv);
  });
  // adicionada pelo botão da PDP: a provisória vira item do carrinho (não conta duas vezes); o cr:cart:html corrige depois.
  // Se a leitura real chegou antes (adição rápida: HTML → aviso), o cr:cart:html já tirou a provisória e aqui nada muda
  document.addEventListener('cr:cart:updated', ({ detail: d }) => {
    if (ocupado || !prov || String(d?.item?.variant_id) !== prov.v) return;
    cart = [...cart, prov];
    prov = null;
    pintar();
  });
  // HTML novo do drawer (cart.js): relê as camisetas do trio no carrinho
  document.addEventListener('cr:cart:html', (e) => {
    const j = e.detail?.querySelector('[data-cr-trio-itens]');
    if (!j) return;
    let novo;
    try { novo = JSON.parse(j.textContent); } catch { return; }
    // L9n-1: a leitura real já tem mais unidades da variante da provisória → ela foi adicionada (por qualquer caminho)
    if (prov && qv(novo, prov.v) > qv(cart, prov.v)) prov = null;
    cart = novo;
    lido++;
    pintar();
  });
  kit.addEventListener('click', async (e) => {
    // MK-S4a: a vaga provisória leva ao seletor de tamanho da PDP
    if (e.target.closest('[data-kit-q]')) { marcado()?.focus(); return; }
    const b = e.target.closest('[data-vaga-btn]');
    // n da vaga para a folha de tamanho ("Camiseta n de k do trio", SL-05)
    // L13a: a folha (abas, Ver mais, topo com as vagas) é o kit-folha.js, carregado no 1º toque pela URL com versão. L13a-1/2
    // (Riff): recebe o estado ATUAL (carrinho + pendentes + provisória), lido quando o módulo chega; se o import falha, tira o inert da folha
    if (b) { alvo = +b.dataset.vagaBtn; kit.dataset.n = alvo + 1; import(kit.dataset.folha).then((m) => m.abrir([...cart, ...lote].map((u) => u.v))).catch(() => document.querySelectorAll('#cr-kit-folha [inert]').forEach((e) => e.removeAttribute('inert'))); return; }
    if (!e.target.closest('[data-kit-cta]') || ocupado) return;
    const nc = unid().length;
    if (nc >= k) { CR.cart.abrir(); return; }
    if (nc + lote.length < k) { $('[data-vaga-btn]:not(.cr-vaga--pendente)')?.focus(); return; }
    ocupado = true;
    // L9b-1 (Riff): POST confirmado → o lote (provisória + pendentes) já está no carrinho, mesmo se a releitura falhar;
    // passa para a lista do carrinho (o próximo cr:cart:html corrige) e um novo clique não reenvia as mesmas peças
    // L9n-1: se a resposta já trouxe a seção (cr:cart:html durante o POST), a leitura real vale e nada é somado
    const l = lote, l0 = lido;
    try { if (await CR.cart.adicionar(l.map((v) => v.v), 'kit_trio')) { if (lido === l0) cart = [...cart, ...l.map((v) => ({ ...v, q: 1 }))]; picks = []; prov = null; pintar(); } } catch { st.textContent = T.erro; }
    ocupado = false;
  });
  pintar();
}
